<template>
  <div class="h-100">
    <SampleSwiper
      v-if="swiper"
      v-bind="$attrs"
      :carrierInfo="carrierInfo"
      :keycode="keycode"
      :typeId="typeId"
      :scopeName="scopeName"
      :sample="sampleVal"
      :carrierId="carrierId"
      :parseVal="parseVal"
    ></SampleSwiper>
  </div>
</template>
<script>
import SampleSwiper from '@/components/SampleValueColumn/SampleSwiper'
import { TempUtils } from '@/utils/TempUtil.js';
export default {
  props: {
    swiper: {
      type: Boolean
    },
    sample: {},
    scopeName: {},
    keycode: {},
    typeId: {},
    carrierId: {},
    carrierInfo: {}
  },
  data () {
    return {
      // 用于承载处理后的数据
      sampleVal: []
    }
  },
  components: {
    SampleSwiper
  },
  mounted () {
    if (this.sample) {
      let data = this.sample
      if (typeof this.sample === 'string') {
        data = JSON.parse(this.sample)
      }
      if (!data.hum) {
        data.hum = []
      }

      this.sampleVal = [
        ...data.hum.map(item => {
          if (!item.code) item.code = 'hum'
          return item
        }),
        ...data.temp.map(item => {
          if (!item.code) item.code = 'temp'
          return item
        })
      ]
    } else {
      this.sampleVal = []
    }
  },
  methods: {
    // 将取样值加上温度 传入监测区间项
    parseVal (item) {
      const { unit } = this.$store.state
      if (item.val) {
        return TempUtils.convertToCelsius(item.val,unit[item.code].name) + unit[item.code].name
      } else {
        return '---'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .range-item {
  .range-tag {
    background-color: var(--primary-color);
    color: white;
    width: 100%;
    text-align: center;
  }

  .info {
    width: 20px;
    text-align: center;
  }

  .time {
    text-align: center;
  }

  .border-right {
    border-right: 1px solid #ccc;
  }

  .val {
    width: 70px;
  }
}
</style>
